<div class="cd-staff-dialog">
  <div class="cd-staff-header">
    <h2 class="cd-staff-title">Staff{{ data.s.name ? ' — ' + data.s.name : '' }}</h2>
    <button type="button" class="cd-staff-close" aria-label="Close dialog" (click)="close()">
      ✕
    </button>
  </div>

  @if (staff$ | async; as staff) {
    @if (error) {
      <div class="cd-staff-status cd-staff-error" role="alert">
        Something went wrong loading staff. Please try again.
      </div>
    } @else if (staff.length === 0) {
      <div class="cd-staff-status">No staff found for this school.</div>
    } @else {
      <div role="list" aria-label="School staff" class="cd-staff-list">
        @for (s of staff; track s.id) {
          <div class="cd-staff-row" role="listitem">
            <div class="cd-staff-avatar" aria-hidden="true">
              <app-user-avatar [imageUrl]="s.profilePicturePath" [name]="s.firstName + ' ' + s.lastName" />
            </div>
            <div class="cd-staff-info">
              <div class="cd-staff-name">{{ s.firstName }} {{ s.lastName }}</div>
              <div class="cd-staff-email">{{ s.email }}</div>
            </div>
            <div class="cd-staff-role" [attr.data-role]="s.userType">
              {{ roleLabel(s.userType) }}
            </div>
          </div>
        }
      </div>
    }
  } @else {
    <div class="cd-staff-status" role="status">Loading staff…</div>
  }
</div>
